import {FRAME_CHARGER_SERIAL} from '../../consts/scp/scpFrames';
import SCP_FRAMES_REQUEST_PRIORITY_TYPES from '../../consts/mw/scpFramesRequestPriorityTypes';
// import iotDeviceFeatureConfigService from '../iotDevice/iotDeviceFeatureConfigService';
import {log} from '../log';
import pairingService from '../pairingService';
import connectivityService from './connectivityService';
import framesProcessingService from './framesProcessingService';

const pingDeviceIfNeeded = () => {
    const isIdlePingNeeded = getIsIdlePingNeeded();

    if (!isIdlePingNeeded) return;

    const isDeviceConnected = pairingService.isDeviceConnected();

    if (!isDeviceConnected) {
        return;
    }

    writePingFrame();
};

const writePingFrame = () => {
    let onErrorWasCalled;

    log.debug('deviceIdlePingService: writePingFrame');

    framesProcessingService.processFrames({
        frames: [FRAME_CHARGER_SERIAL],
        retryCount: 0,
        priority: SCP_FRAMES_REQUEST_PRIORITY_TYPES.TOP_PRIORITY,
        onError: () => {
            // prevent infinite loop from stopDeviceSchedulers->clearQueue->onError
            if (onErrorWasCalled) return;
            onErrorWasCalled = true;

            // TODO: replace with new onDeviceDisconnect callback
            // pairingService.onDeviceDisconnect();
        },
    });
};

const getIsIdlePingNeeded = () => {
    const isBle = connectivityService.isBle();

    if (!isBle) return false;

    // TODO: add iotDeviceFeatureConfigService
    // const isIdlePingEnabled = iotDeviceFeatureConfigService.isIdlePingEnabled();

    // return isIdlePingEnabled;
};

export default {
    pingDeviceIfNeeded,
    getIsIdlePingNeeded,
    writePingFrame,
};
